import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { OrderService } from '../order.service';
import { Order } from '../order';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class OrdersComponent implements OnInit {
  orders: any

  constructor(private order: OrderService) { }

  ngOnInit() {
    this.order.get().subscribe((Result: any) => {
      this.orders = Result
console.log(Result);
    });
  }
}
